export const FLOW_TYPES = {
  ACTIVITIES_ONLY: "ACTIVITIES_ONLY",
  ADMISSION: "ADMISSION",
  GIFT_CARD: "GIFT_CARD",
};
